<template>
  <div class="scatterplot">
    <div v-if="tracks.length === 0" style="width: 70%; margin: 10px; background: #ebebeb; padding: 20px;">
      Select genes and data types on the left to generate a scatterplot.
    </div>
    <div :id="divId">
    </div>
  </div>
</template>

<script>
import { property } from 'lodash'
import scatterplot from '../../plotly/scatterplotly'

export default {
    name: "scatterplot",

    props: ['studySelected'],

    data: () => ({
    }),
    
    computed: {
      divId() { return 'scatterplotly' },
      trackA() { 
        console.log('scatterplot.vue trackA', this.tracks[0])
        return this.trackData[this.tracks[0]] 
      },
      trackB() { return this.trackData[this.tracks[1]] },
      tracks() { return this.$store.state.Scatterplot_tracks },
      useZScore() { return this.$store.state.Scatterplot_useZScore },
      trackDataNormalized() { return this.$store.state.Scatterplot_data },
      trackDataRaw() { return this.$store.state.Scatterplot_data_raw },
      trackData() { return this.useZScore ? 
        this.trackDataNormalized 
        : this.trackDataRaw 
      },
      cohortSelected() { 
            console.log('pfsData Scatterplot.vue', this.$store.state.Scatterplot_cohortSelected)
            return this.$store.state.Scatterplot_cohortSelected 
      },
    },

    watch: {
      tracks() { this.renderScatterplot() },
      trackData() { this.renderScatterplot() },
      useZScore() { this.renderScatterplot() },
      cohortSelected() { this.renderScatterplot() },
    },

    methods: {
      renderScatterplot() {
        scatterplot({
          divId: this.divId,
          trackA: this.trackA,
          trackB: this.trackB,
          useZScore: this.useZScore,
          wholeTrackData: this.trackData,
          cohortSelected: this.cohortSelected,
          studySelected: this.studySelected
        })
      },
    },

    mounted() {

    },
  }
</script>

<style>
.scatterplot {
    width: 100%;
    height: 200%;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
    /* margin: 10px; */
    /* padding-left: 10px; */
    overflow: scroll; /* Direct aspect ratio control */

}
.scatterplotly {
    width: 100%;
    height: 200%;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
    /* margin: 10px; */
    /* padding-left: 10px; */
    overflow: scroll; /* Direct aspect ratio control */

}
</style>